// extracted by mini-css-extract-plugin
export var forgotPasswordPaperClassName = "SignUpSignInModal-module--forgotPasswordPaperClassName--f2d32";
export var formWrapper = "SignUpSignInModal-module--formWrapper--b3abc";
export var modal = "SignUpSignInModal-module--modal--d7904";
export var title = "SignUpSignInModal-module--title--c610d";